import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { SaveUserBasicInfoinAllApplications } from '../../../AdminActionCreator.component';



const textFieldData = [
    { label: "Care Of", value: "careOf", placeholder: "Enter Care Of", type: "text", name: "careOf" },
    { label: "Relation With Care Of", value: "relationWithCareOf", placeholder: "Enter Relation With Care Of", type: "text", name: "relationWithCareOf" },
    { label: "Caste", value: "caste", placeholder: "Enter caste", type: "text", name: "caste" },
    { label: "Marital Status", value: "maritalStatus", placeholder: "Enter Marital Status", type: "text", name: "maritalStatus" },
    { label: "Education Qualification", value: "highestQualification", placeholder: "Enter Education Qualification", type: "text", name: "highestQualification" },
    { label: "Total Family Members", value: "totalFamilyMember", placeholder: "Enter Total Family Members", type: "number", name: "totalFamilyMember" },
    { label: "No Of Earning Members", value: "noOfEarningMembers", placeholder: "Enter No Of Earning Members", type: "number", name: "noOfEarningMembers" },
]

export default function EditPersonalDetail({ data, closePopup, customStyle, handleLoader, handleTextPopup, closeTextPopup, admin }) {
    const [objectData, setObjectData] = useState({
        "careOf": "",
        "relationWithCareOf": "",
        "caste": "",
        "maritalStatus": "",
        "highestQualification": "",
        "totalFamilyMember": "",
        "noOfEarningMembers": "",
    });

    const handleInputValues = (e) => {
        const { name, value } = e.target;

        setObjectData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        console.log("data", data)
        if (data?.userId) {
            setObjectData({
                "careOf": data?.careOf || "",
                "relationWithCareOf": data?.relationWithCareOf || "",
                "caste": data?.caste || "",
                "maritalStatus": data?.maritalStatus || "",
                "highestQualification": data?.highestQualification || "",
                "totalFamilyMember": data?.totalFamilyMember || "",
                "noOfEarningMembers": data?.noOfEarningMembers || "",
            })
        } else {
            setObjectData({
                "careOf": "",
                "relationWithCareOf": "",
                "caste": "",
                "maritalStatus": "",
                "highestQualification": "",
                "totalFamilyMember": "",
                "noOfEarningMembers": "",
            })
        }
    }, [])


    const handleSave = () => {
        const obj = { ...objectData, userId: data?.userId,
"formStatus":"update",
              "empId":admin?.emailId

         }
        handleLoader(true)
        SaveUserBasicInfoinAllApplications(obj, callback => {
            if (callback?.message == "success" && callback?.status == 200) {
                handleTextPopup(true, "Basic Information Updated Successfully")
            } else {
                handleTextPopup(true, "Error Updating Basic Information")
            }
            handleLoader(false)
            closeTextPopup()
        })
    }


    return (
        <>
            <div className='background-blur income' style={customStyle}>
                <div className='popup-main small-popup container-fluid dbl-border'>
                    <button className='close' onClick={e => closePopup()}>
                        &times;
                    </button>
                    <h4 style={{ color: '#000' }}>Edit Basic Details</h4>

                    <div className="row">
                        {
                            textFieldData && textFieldData?.map((value, index) => {
                                return (
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>

                                        {
                                            value?.name !== "salutation" && value?.name !== "gender" && value?.name !== "preferredLanguage" ?

                                                <TextField fullWidth id="outlined-basic" label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]}
                                                    placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} />
                                                :
                                                value?.name == "salutation" ?
                                                    <TextField fullWidth id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]} placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} >
                                                        {salutationData?.map((option) => (
                                                            <MenuItem key={option.value} value={option.label}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                    :
                                                    value?.name == "gender" ?
                                                        <TextField fullWidth id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]} placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} >
                                                            {genderData?.map((option) => (
                                                                <MenuItem key={option.value} value={option.label}>
                                                                    {option.label}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>

                                                        :
                                                        value?.name == "preferredLanguage" ?
                                                            <TextField fullWidth id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]} placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} >
                                                                {LanguageData?.map((option) => (
                                                                    <MenuItem key={option.value} value={option.label}>
                                                                        {option.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </TextField>
                                                            :
                                                            ""
                                        }

                                    </div>
                                )
                            })
                        }

                        <div className="col-xs-12" style={{ marginTop: '20px', textAlign: 'center' }}>
                            <button className='btn btn-primary' onClick={() => handleSave()}>Save</button>
                        </div>
                    </div>

                </div>


            </div >
        </>
    )
}
